module.exports = __webpack_public_path__ + "img/irb.790659fd.png";